export { default } from './UnscoredCategoryPageBackgroundTextureExpertSection'
